
export function randomString() {
  return Math.floor(Math.random() * 10000000000).toString(36).substring(0, 6);
}
